// // client/src/components/TestingPage.js
// import React, { useState, useEffect, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios'; // Import axios for HTTP requests
// import { v4 as uuidv4 } from 'uuid';
// import './../App.css'; // Use App's CSS

// // Define the backend URL (FastAPI server)
// const API_BASE_URL = "https://qa-automator-api.sodio.tech";
// // const SERVER_URL = "https://qa-automator-api.sodio.tech";

// const TestingPage = () => {
//     const { encodedUrl } = useParams();
//     const targetUrl = decodeURIComponent(encodedUrl);
//     const [goal, setGoal] = useState(''); // Primary goal/objective text
//     const [steps, setSteps] = useState([]); // Array to store manually defined steps
//     const [currentStepType, setCurrentStepType] = useState('click');
//     const [currentSelector, setCurrentSelector] = useState('');
//     const [currentValue, setCurrentValue] = useState('');

//     // State for API interaction and results
//     const [taskId, setTaskId] = useState(null);
//     const [liveUrl, setLiveUrl] = useState(null);
//     const [status, setStatus] = useState(null); // e.g., 'running', 'finished', 'failed'
//     const [logs, setLogs] = useState([]); // Logs fetched from backend
//     const [isRunning, setIsRunning] = useState(false);
//     const [testResult, setTestResult] = useState(null); // 'success' or 'failure'

//     const pollingIntervalRef = useRef(null); // Ref to store interval ID
//     const rightPanelEndRef = useRef(null); // Ref for scrolling logs

//     const stepTypes = [
//         'click', 'fill', 'type', 'select', 'wait', 'press', 'navigate'
//     ];

//     // --- Helper to Add Log Messages Locally ---
//     const logMessage = (message, type = 'info') => {
//         const text = typeof message === 'string' ? message : JSON.stringify(message);
//          // Add unique ID for React key, useful for local logs before API logs arrive
//         setLogs(prevLogs => [...prevLogs, { text: text, type: type, id: uuidv4() }]);
//     };

//     // --- Step Management (No changes needed) ---
//     const handleAddStep = (e) => {
//         e.preventDefault();
//         if (['click', 'fill', 'type', 'select', 'press'].includes(currentStepType)) {
//              if (!currentSelector) {
//                  alert(`Selector is required for step type: ${currentStepType}.`);
//                  return;
//              }
//         }
//         if (['fill', 'type', 'select', 'press', 'navigate'].includes(currentStepType) || (currentStepType === 'wait' && !currentSelector)) {
//             if (!currentValue && currentStepType !== 'wait') {
//                  alert(`Value is required for step type: ${currentStepType}.`);
//                  return;
//              }
//         }
//         const newStep = { id: uuidv4(), type: currentStepType, selector: currentSelector || null, value: currentValue || null };
//         setSteps([...steps, newStep]);
//         setCurrentSelector('');
//         setCurrentValue('');
//     };
//     const handleRemoveStep = (idToRemove) => {
//         setSteps(steps.filter(step => step.id !== idToRemove));
//     };
//     const formatStepsForTask = () => {
//         if (steps.length === 0) return "";
//         let formattedSteps = "\n\nDetailed Steps to Follow:\n";
//         steps.forEach((step, index) => {
//             formattedSteps += `${index + 1}. Type: ${step.type}`;
//             if (step.selector) formattedSteps += `, Selector: "${step.selector}"`;
//             if (step.value) formattedSteps += `, Value: "${step.value}"`;
//             formattedSteps += "\n";
//         });
//         return formattedSteps;
//     };

//     // --- Test Execution ---
//     const handleRunTest = async () => { // Make async
//         if (isRunning) return;
//         if (!goal.trim() && steps.length === 0) {
//              alert("Please enter a Goal or add at least one Step before running the agent.");
//              return;
//         }

//         const formattedStepsString = formatStepsForTask();
//         const combinedTask = `${goal}${formattedStepsString}`;

//         // Reset state for new run
//         setIsRunning(true);
//         setLogs([]); // Clear previous logs
//         setTaskId(null);
//         setLiveUrl(null);
//         setStatus('starting');
//         setTestResult(null);
//         if (pollingIntervalRef.current) { // Clear any previous interval
//             clearInterval(pollingIntervalRef.current);
//             pollingIntervalRef.current = null;
//         }

//         logMessage(`Starting agent test for URL: ${targetUrl}`);
//         logMessage(`Task:\n${combinedTask}`);

//         try {
//             // Call the FastAPI backend to start the task
//             const response = await axios.post(`${API_BASE_URL}/api/run-task`, {
//                 url: targetUrl,
//                 task: combinedTask
//             });

//             if (response.data && response.data.taskId && response.data.liveUrl) {
//                 setTaskId(response.data.taskId);
//                 setLiveUrl(response.data.liveUrl);
//                 setStatus('running'); // Task created, now running
//                 logMessage(`Agent task created: ID=${response.data.taskId}`, 'success');
//                 // Start polling for status and logs
//                 startPolling(response.data.taskId);
//             } else {
//                 throw new Error(response.data?.error || "Failed to start task: Invalid response from backend.");
//             }

//         } catch (error) {
//             console.error("Error starting agent task:", error);
//             const errorMsg = error.response?.data?.detail || error.message || "An unknown error occurred.";
//             logMessage(`Error starting task: ${errorMsg}`, 'error');
//             setIsRunning(false);
//             setStatus('failed');
//             setTestResult('failure');
//         }
//     };

//     // --- Polling for Task Status and Logs ---
//     const startPolling = (currentTaskId) => {
//         if (pollingIntervalRef.current) {
//             clearInterval(pollingIntervalRef.current); // Clear existing interval if any
//         }

//         pollingIntervalRef.current = setInterval(async () => {
//             if (!currentTaskId) { // Safety check
//                  clearInterval(pollingIntervalRef.current);
//                  pollingIntervalRef.current = null;
//                  return;
//              }

//             try {
//                 const response = await axios.get(`${API_BASE_URL}/api/task/${currentTaskId}/details`);
//                 const data = response.data;

//                 // Update status
//                 if (data.status) {
//                      setStatus(data.status);
//                 }

//                  // Update logs - Adjust based on actual API response structure
//                  // Assuming logs are an array of strings or objects under 'logs' key
//                  if (Array.isArray(data.logs)) {
//                      // Simple approach: Replace logs entirely with fetched logs
//                      // More complex: Diff and append new logs (requires log IDs or timestamps)
//                      // Add unique IDs for React keys if logs are just strings
//                      setLogs(data.logs.map((log, index) => ({
//                          id: `${currentTaskId}-log-${index}`, // Generate somewhat unique ID
//                          text: typeof log === 'string' ? log : JSON.stringify(log), // Handle string or object logs
//                          type: 'info' // Assume info type for now
//                      })));
//                  } else if (data.result && typeof data.result === 'string') {
//                     // Sometimes the final result might contain log-like info
//                     // This is a fallback, adjust as needed.
//                     setLogs([{id: uuidv4(), text: `Result: ${data.result}`, type: 'info'}])
//                  }

//                 // Check for terminal status
//                 const terminalStatuses = ['finished', 'failed', 'stopped', 'error']; // Add 'error' if API uses it
//                 if (terminalStatuses.includes(data.status)) {
//                     clearInterval(pollingIntervalRef.current);
//                     pollingIntervalRef.current = null;
//                     setIsRunning(false);
//                     setTestResult(data.status === 'finished' ? 'success' : 'failure');
//                     logMessage(`Polling stopped. Final Status: ${data.status}`, data.status === 'finished' ? 'success' : 'error');
//                     // Fetch one last time to ensure logs/result are final? Optional.
//                 }

//             } catch (error) {
//                 console.error("Error polling task status:", error);
//                 // Don't stop polling on transient network errors, but log them
//                 logMessage(`Error polling status: ${error.message}`, 'error');
//                  // Maybe stop polling after several consecutive errors? Add counter logic if needed.
//                  // For now, continue polling. If the backend returns a specific error structure, use that.
//                  if (error.response?.data?.detail) {
//                      logMessage(`Backend polling error: ${error.response.data.detail}`, 'error');
//                  }
//                  // Decide if certain errors should stop polling
//                  if (error.response?.status === 404) { // Task ID not found
//                      logMessage(`Task ID ${currentTaskId} not found. Stopping polling.`, 'error');
//                      clearInterval(pollingIntervalRef.current);
//                      pollingIntervalRef.current = null;
//                      setIsRunning(false);
//                      setStatus('error');
//                      setTestResult('failure');
//                  }
//             }
//         }, 3000); // Poll every 3 seconds (adjust as needed)
//     };

//      // --- Cleanup Polling on Unmount ---
//      useEffect(() => {
//          // Return cleanup function
//          return () => {
//              if (pollingIntervalRef.current) {
//                  clearInterval(pollingIntervalRef.current);
//              }
//          };
//      }, []); // Empty dependency array ensures this runs only on mount and unmount

//      // Auto-scroll logs pane
//      useEffect(() => {
//         rightPanelEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [logs]);


//     return (
//         <div className="testing-page">
//             {/* Left Panel (Configuration) */}
//             <div className="left-panel">
//                 {/* ... (Goal Input, Steps List, Add Step Form - No changes needed from previous version) ... */}
//                  <h2 className="panel-title">Agent Configuration</h2>
//                  <div className="input-group">
//                      <label htmlFor="goal">Overall Goal / Objective</label>
//                      <textarea id="goal" value={goal} onChange={(e) => setGoal(e.target.value)} placeholder="Describe the main objective..." rows={3} />
//                  </div>
//                  <h3 className="panel-title steps-title">Detailed Steps (Optional Guidance)</h3>
//                  <div className="steps-list">
//                      {steps.length === 0 && <p className="no-steps-msg">No specific steps added.</p>}
//                      {steps.map((step, index) => (
//                          <div key={step.id} className="step-item">
//                              <span className="step-type-badge">{step.type}</span>
//                              <div className="step-details">
//                                  {step.selector && <div><span>Selector:</span> {step.selector}</div>}
//                                  {step.value && <div><span>Value:</span> {step.value}</div>}
//                              </div>
//                              <div className="step-actions"><button onClick={() => handleRemoveStep(step.id)} title="Remove Step">×</button></div>
//                          </div>
//                      ))}
//                  </div>
//                  <form className="add-step-form" onSubmit={handleAddStep}>
//                      <h4>Add New Step</h4>
//                      <div className="add-step-controls">
//                          <select value={currentStepType} onChange={(e) => setCurrentStepType(e.target.value)}>
//                              {stepTypes.map(type => <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)}
//                          </select>
//                          <input type="text" placeholder="Selector (e.g., #id, .class)" value={currentSelector} onChange={(e) => setCurrentSelector(e.target.value)} aria-label="CSS Selector"/>
//                          <input type="text" placeholder="Value (e.g., text, URL, key)" value={currentValue} onChange={(e) => setCurrentValue(e.target.value)} aria-label="Value"/>
//                      </div>
//                      <button type="submit" className="add-step-button">Add Step</button>
//                  </form>


//                 <button
//                     className="run-button"
//                     style={{ marginTop: '20px' }}
//                     onClick={handleRunTest}
//                     disabled={isRunning || (!goal.trim() && steps.length === 0)}
//                 >
//                     {isRunning ? 'Agent Running...' : 'Run Agent Test'}
//                 </button>
//             </div>

            
                

//             {/* Right Panel (Live View & Logs) */}
//             <div className="right-panel" style={{ display: 'flex', flexDirection: 'column' }}>
//                  {/* Top Section: Live Execution View */}
//                  <div className="live-view-section"> {/* Existing class */}
//                      <h2 className="panel-title"> {/* Title */}
//                          <span style={{color: '#3498db'}}>{"<--"}</span>------- REAL TIME EXECUTION -------<span style={{color: '#3498db'}}>{"-->"}</span>
//                      </h2>

//                      {/* === MODIFICATION START === */}
//                      {/* Add a wrapper div for aspect ratio control */}
//                      <div className="live-view-iframe-container">
//                          {liveUrl && (isRunning || status === 'finished' || status === 'failed') ? ( // Keep iframe visible even after run finishes
//                              <iframe
//                                  src={liveUrl}
//                                  className="live-view-iframe" // Add specific class to iframe
//                                  title="Browser Use Live Preview"
//                              />
                             
//                          ) : (
//                              <div className="live-view-placeholder"> {/* Keep placeholder */}
//                                  {isRunning ? 'AI Agent is currently processing the test steps...' : 'Live view will appear here when test is running.'}
//                              </div>
//                          )
//                         }
//                      </div>
//                      {/* === MODIFICATION END === */}

//                      {status && <div className="status">Status: {status}</div>}
//                  </div>
            


//                  {/* Bottom Section: Logs */}
//                  <div className="logs-section" style={{ flex: '1', padding: '10px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}> {/* Let logs take remaining space */}
//                       <h2 className="panel-title" style={{ marginBottom: '10px', borderBottom: 'none', paddingBottom: '0' }}>AI OUTPUT LOGS</h2>
//                       <div className="status-log" style={{ flexGrow: 1, overflowY: 'auto' }}> {/* Make log container scrollable */}
//                           {logs.map((log) => (
//                               <div key={log.id} className={`log-entry ${log.type === 'error' ? 'log-error' : ''} ${log.type === 'success' ? 'log-success' : ''}`}>
//                                   <span style={{ whiteSpace: 'pre-wrap' }}>{log.text}</span>
//                               </div>
//                           ))}
//                           <div ref={rightPanelEndRef} />
//                       </div>
//                   </div>

//                  {/* Test Result Display (Keep outside the flex container or adjust layout) */}
//                  {testResult && (
//                      <div style={{ padding: '10px', borderRadius: '4px', backgroundColor: testResult === 'success' ? '#d4edda' : '#f8d7da', color: testResult === 'success' ? '#155724' : '#721c24', marginTop: '10px' }}>
//                          Final Test Result: {testResult.toUpperCase()}
//                      </div>
//                  )}
//             </div>
//         </div>
//     );
// };

// export default TestingPage;


// // client/src/components/TestingPage.js
// import React, { useState, useEffect, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import { v4 as uuidv4 } from 'uuid';
// import './../App.css';

// const API_BASE_URL = "https://qa-automator-api.sodio.tech";

// const TestingPage = () => {
//     const { encodedUrl } = useParams();
//     const targetUrl = decodeURIComponent(encodedUrl);
//     const [goal, setGoal] = useState('');
//     const [steps, setSteps] = useState([]);
//     const [currentStepType, setCurrentStepType] = useState('click');
//     const [currentSelector, setCurrentSelector] = useState('');
//     const [currentValue, setCurrentValue] = useState('');
//     const [taskId, setTaskId] = useState(null);
//     const [liveUrl, setLiveUrl] = useState(null);
//     const [status, setStatus] = useState(null);
//     const [logs, setLogs] = useState([]);
//     const [finalAgentResultText, setFinalAgentResultText] = useState(null); // Store the raw final result text
//     const [isRunning, setIsRunning] = useState(false);
//     const [testResult, setTestResult] = useState(null); // 'success' or 'failure'

//     const pollingIntervalRef = useRef(null);
//     const rightPanelEndRef = useRef(null);

//     const stepTypes = [
//         'click', 'fill', 'type', 'select', 'wait', 'press', 'navigate'
//     ];

//     const logMessage = (message, type = 'info') => {
//         const text = typeof message === 'string' ? message : JSON.stringify(message);
//         setLogs(prevLogs => [...prevLogs, { text: text, type: type, id: uuidv4() }]);
//     };

//     // --- Step Management (No changes) ---
//     const handleAddStep = (e) => { e.preventDefault(); if (['click', 'fill', 'type', 'select', 'press'].includes(currentStepType)) { if (!currentSelector) { alert(`Selector is required for step type: ${currentStepType}.`); return; } } if (['fill', 'type', 'select', 'press', 'navigate'].includes(currentStepType) || (currentStepType === 'wait' && !currentSelector)) { if (!currentValue && currentStepType !== 'wait') { alert(`Value is required for step type: ${currentStepType}.`); return; } } const newStep = { id: uuidv4(), type: currentStepType, selector: currentSelector || null, value: currentValue || null }; setSteps([...steps, newStep]); setCurrentSelector(''); setCurrentValue(''); };
//     const handleRemoveStep = (idToRemove) => { setSteps(steps.filter(step => step.id !== idToRemove)); };
//     const formatStepsForTask = () => { if (steps.length === 0) return ""; let formattedSteps = "\n\nDetailed Steps to Follow:\n"; steps.forEach((step, index) => { formattedSteps += `${index + 1}. Type: ${step.type}`; if (step.selector) formattedSteps += `, Selector: "${step.selector}"`; if (step.value) formattedSteps += `, Value: "${step.value}"`; formattedSteps += "\n"; }); return formattedSteps; };

//     // --- handleRunTest Function ---
//     const handleRunTest = async () => {
//         // ... (rest of handleRunTest remains the same as the last version)
//         // ... (constructs combinedTask, calls API)
//         if (isRunning) return;
//         if (!goal.trim() && steps.length === 0) { alert("Please enter a Goal or add at least one Step before running the agent."); return; }

//         const formattedStepsString = formatStepsForTask();
//         const goalInstruction = `\n\nYour primary objective is: "${goal}".`;
//         // This instruction's output (SUCCESS/FAILURE keyword) is NO LONGER PARSED for pass/fail
//         // const finalInstruction = `\n\n**NOTE:** After attempting the steps, evaluate if the primary objective ('${goal}') was successfully achieved. Your evaluation might be logged, but the final Pass/Fail of this test run is determined by whether the automation completed technically without API errors.`; // Modified instruction text for clarity

//         const combinedTask = `${goalInstruction}${formattedStepsString}`;

//         setIsRunning(true);
//         setLogs([]);
//         setTaskId(null);
//         setLiveUrl(null);
//         setStatus('starting');
//         setTestResult(null);
//         setFinalAgentResultText(null);
//         if (pollingIntervalRef.current) { clearInterval(pollingIntervalRef.current); pollingIntervalRef.current = null; }

//         logMessage(`Starting agent test for URL: ${targetUrl}`);
//         logMessage(`Task being sent to agent:\n${combinedTask}`);

//         try {
//             const response = await axios.post(`${API_BASE_URL}/api/run-task`, { url: targetUrl, task: combinedTask });
//             if (response.data && response.data.taskId && response.data.liveUrl) {
//                 setTaskId(response.data.taskId);
//                 setLiveUrl(response.data.liveUrl);
//                 setStatus('running');
//                 logMessage(`Agent task created: ID=${response.data.taskId}`, 'success');
//                 startPolling(response.data.taskId);
//             } else { throw new Error(response.data?.error || "Failed to start task: Invalid response from backend."); }
//         } catch (error) {
//             console.error("Error starting agent task:", error);
//             const errorMsg = error.response?.data?.detail || error.message || "An unknown error occurred.";
//             logMessage(`Error starting task: ${errorMsg}`, 'error');
//             setIsRunning(false);
//             setStatus('failed');
//             setTestResult('failure');
//         }
//     };

//     // --- Polling for Task Status and Logs ---
//     const startPolling = (currentTaskId) => {
//         if (pollingIntervalRef.current) {
//             clearInterval(pollingIntervalRef.current);
//         }

//         pollingIntervalRef.current = setInterval(async () => {
//             if (!currentTaskId) {
//                  clearInterval(pollingIntervalRef.current);
//                  pollingIntervalRef.current = null;
//                  return;
//              }

//             try {
//                 const response = await axios.get(`${API_BASE_URL}/api/task/${currentTaskId}/details`);
//                 const data = response.data; // Expects { status: ..., output: ..., live_url: ... }

//                 if (data.status) {
//                      setStatus(data.status);
//                 }

//                 // Log handling remains the same - display final output when finished
//                 // (As noted before, intermediate logs require backend changes)

//                 const terminalStatuses = ['finished', 'failed', 'stopped', 'error'];
//                 if (terminalStatuses.includes(data.status)) {
//                     clearInterval(pollingIntervalRef.current);
//                     pollingIntervalRef.current = null;
//                     setIsRunning(false);

//                     // === MODIFICATION START: Robust keyword analysis of agent's "output" ===
//                     let finalOutcome = 'failure'; // Default to failure unless positive keywords found AND no negative keywords found
//                     const agentOutput = data.output;
//                     setFinalAgentResultText(agentOutput || "No final output text provided by agent.");

//                     logMessage(`Received final agent output:\n---\n${agentOutput || '(No output received)'}\n---`);

//                     if (agentOutput && typeof agentOutput === 'string') {
//                         const outputLower = agentOutput.toLowerCase(); // Case-insensitive matching

//                         // Define keywords indicating failure (prioritize these)
//                         const negativeKeywords = [
//                             "fail", "failed", "error", "unable", "could not",
//                             "invalid", "incorrect", "exception", "problem",
//                             "cannot", "can't", "did not complete", "not successful"
//                         ];

//                         // Define keywords indicating success
//                         const positiveKeywords = [
//                             "success", "successfully", "completed", "accessed",
//                             "verified", "achieved", "logged in", "dashboard accessed", // Add domain specific terms
//                             "objective met", "goal achieved", "confirmed", "validated",
//                             "works correctly" // From user example
//                         ];

//                         let foundNegative = false;
//                         for (const keyword of negativeKeywords) {
//                             if (outputLower.includes(keyword)) {
//                                 logMessage(`Detected failure indicator: "${keyword}"`, "error");
//                                 finalOutcome = 'failure';
//                                 foundNegative = true;
//                                 break; // Stop checking negatives if one is found
//                             }
//                         }

//                         // Only check for positives if no negatives were found
//                         if (!foundNegative) {
//                             let foundPositive = false;
//                             for (const keyword of positiveKeywords) {
//                                 if (outputLower.includes(keyword)) {
//                                     logMessage(`Detected success indicator: "${keyword}"`, "success");
//                                     finalOutcome = 'success'; // Set to success if a positive is found
//                                     foundPositive = true;
//                                     break; // Stop checking positives if one is found
//                                 }
//                             }
//                             if (!foundPositive) {
//                                 logMessage("No clear positive or negative keywords found in agent output, assuming failure.", "error");
//                                 // finalOutcome remains 'failure' (the default)
//                             }
//                         }
//                     } else {
//                          logMessage("Agent finished but provided no text output to analyze.", "error");
//                          // finalOutcome remains 'failure'
//                     }

//                     // --- Keep Override Logic: API technical failure means test failure ---
//                     if(data.status === 'failed' || data.status === 'error' || data.status === 'stopped'){
//                         finalOutcome = 'failure'; // Force failure
//                         logMessage(`API task status is ${data.status}, overriding final outcome to FAILURE.`, "error");
//                     }
//                     // --- End Override Logic ---

//                     setTestResult(finalOutcome);
//                     logMessage(`Polling stopped. Final API Status: ${data.status}. Determined Outcome based on Output Analysis: ${finalOutcome.toUpperCase()}`, finalOutcome === 'success' ? 'success' : 'error');
//                     // === MODIFICATION END ===
//                 }

//             } catch (error) {
//                  // --- Keep Existing Error Handling for Polling ---
//                 console.error("Error polling task status:", error);
//                 logMessage(`Error polling status: ${error.message}`, 'error');
//                  if (error.response?.data?.detail) {
//                      logMessage(`Backend polling error: ${error.response.data.detail}`, 'error');
//                  }
//                  if (error.response?.status === 404) {
//                      logMessage(`Task ID ${currentTaskId} not found. Stopping polling.`, 'error');
//                      clearInterval(pollingIntervalRef.current);
//                      pollingIntervalRef.current = null;
//                      setIsRunning(false);
//                      setStatus('error');
//                      setTestResult('failure');
//                  }
//             }
//         }, 3000); // Poll every 3 seconds
//     };

//      // --- Cleanup Polling on Unmount ---
//      useEffect(() => { return () => { if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current); }; }, []);

//      // Auto-scroll logs pane
//      useEffect(() => { rightPanelEndRef.current?.scrollIntoView({ behavior: "smooth" }); }, [logs]);


//     return (
//         <div className="testing-page">
//             {/* Left Panel (No changes needed in JSX structure) */}
//             <div className="left-panel">
//                  <h2 className="panel-title">Agent Configuration</h2>
//                  <div className="input-group">
//                      <label htmlFor="goal">Overall Goal / Objective</label>
//                      <textarea id="goal" value={goal} onChange={(e) => setGoal(e.target.value)} placeholder="Describe the main objective..." rows={3} />
//                  </div>
//                  <h3 className="panel-title steps-title">Detailed Steps (Optional Guidance)</h3>
//                  <div className="steps-list">
//                      {steps.length === 0 && <p className="no-steps-msg">No specific steps added.</p>}
//                      {steps.map((step, index) => ( <div key={step.id} className="step-item"><span className="step-type-badge">{step.type}</span><div className="step-details">{step.selector && <div><span>Selector:</span> {step.selector}</div>}{step.value && <div><span>Value:</span> {step.value}</div>}</div><div className="step-actions"><button onClick={() => handleRemoveStep(step.id)} title="Remove Step">×</button></div></div> ))}
//                  </div>
//                  <form className="add-step-form" onSubmit={handleAddStep}>
//                      <h4>Add New Step</h4>
//                      <div className="add-step-controls">
//                          <select value={currentStepType} onChange={(e) => setCurrentStepType(e.target.value)}> {stepTypes.map(type => <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)} </select>
//                          <input type="text" placeholder="Selector (e.g., #id, .class)" value={currentSelector} onChange={(e) => setCurrentSelector(e.target.value)} aria-label="CSS Selector"/>
//                          <input type="text" placeholder="Value (e.g., text, URL, key)" value={currentValue} onChange={(e) => setCurrentValue(e.target.value)} aria-label="Value"/>
//                      </div>
//                      <button type="submit" className="add-step-button">Add Step</button>
//                  </form>
//                 <button className="run-button" style={{ marginTop: '20px' }} onClick={handleRunTest} disabled={isRunning || (!goal.trim() && steps.length === 0)}> {isRunning ? 'Agent Running...' : 'Run Agent Test'} </button>
//             </div>

//             {/* Right Panel (No changes needed in JSX structure) */}
//             <div className="right-panel" style={{ display: 'flex', flexDirection: 'column' }}>
//                  <div className="live-view-section">
//                      <h2 className="panel-title"> <span style={{color: '#3498db'}}>{"<--"}</span>------- REAL TIME EXECUTION / SITE PREVIEW -------<span style={{color: '#3498db'}}>{"-->"}</span> </h2>
//                      <div className="live-view-iframe-container">
//                          <iframe src={liveUrl || targetUrl} key={liveUrl || targetUrl} className="live-view-iframe" title="Live Preview / Initial Site View"/>
//                      </div>
//                      {status && <div className="status">Status: {status}</div>}
//                  </div>
//                  <div className="logs-section">
//                       <h2 className="panel-title">AI OUTPUT LOGS</h2>
//                       <div className="status-log" style={{ flexGrow: 1, overflowY: 'auto' }}>
//                           {logs.map((log) => ( <div key={log.id} className={`log-entry ${log.type === 'error' ? 'log-error' : ''} ${log.type === 'success' ? 'log-success' : ''}`}> <span style={{ whiteSpace: 'pre-wrap' }}>{log.text}</span> </div> ))}
//                           {/* Optionally display the raw final result text */}
//                           {finalAgentResultText && <div className='log-entry' style={{borderTop: '1px dashed #ccc', marginTop: '10px', paddingTop:'5px', fontStyle:'italic', color:'#aaa'}}></div>}
//                           <div ref={rightPanelEndRef} />
//                       </div>
//                   </div>
//                  {testResult && ( <div style={{ padding: '10px', borderRadius: '4px', backgroundColor: testResult === 'success' ? '#d4edda' : '#f8d7da', color: testResult === 'success' ? '#155724' : '#721c24', marginTop: '10px' }}> Final Test Result: {testResult.toUpperCase()} </div> )}
//             </div>
//         </div>
//     );
// };

// export default TestingPage;

// client/src/components/TestingPage.js
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import './../App.css';

// Helper function to extract potential verbs from a goal string
// This is a simple implementation - in a production environment, you might want to use NLP libraries
const extractVerbs = (text) => {
    // Common verbs that might appear in goals
    const commonVerbs = [
        "login", "log in", "sign in", "signin", "register", "signup", "sign up",
        "submit", "fill", "enter", "type", "click", "select", "check", "uncheck",
        "navigate", "go", "visit", "access", "open", "close", "verify", "validate",
        "confirm", "search", "find", "locate", "identify", "complete", "finish",
        "add", "remove", "delete", "update", "edit", "modify", "change", "create",
        "upload", "download", "view", "read", "browse", "scroll", "drag", "drop"
    ];

    // Find all common verbs that appear in the text
    return commonVerbs.filter(verb => text.includes(verb));
};

const API_BASE_URL = "https://qa-automator-api.letest.ai";
// const API_BASE_URL = "http://localhost:8000"

const TestingPage = () => {
    const { encodedUrl } = useParams();
    const targetUrl = decodeURIComponent(encodedUrl);
    console.log("Target URL:", targetUrl); // Debugging line to check the URL
    const [goal, setGoal] = useState('');
    const [steps, setSteps] = useState([]);
    const [currentStepType, setCurrentStepType] = useState('click');
    const [currentSelector, setCurrentSelector] = useState('');
    const [currentValue, setCurrentValue] = useState('');
    // State for tracking the current task ID from the API
    const [taskId, setTaskId] = useState(null);
    // Using taskId in the following places:
    // 1. Reset in handleRunTest (line ~407)
    // 2. Set from API response (line ~420)
    // 3. Used in startPolling function
    const [liveUrl, setLiveUrl] = useState(null);
    const [status, setStatus] = useState(null);
    const [logs, setLogs] = useState([]);
    const [finalAgentResultText, setFinalAgentResultText] = useState(null); // Store the raw final result text
    const [isRunning, setIsRunning] = useState(false);
    const [testResult, setTestResult] = useState(null); // 'success' or 'failure'

    const pollingIntervalRef = useRef(null);
    const rightPanelEndRef = useRef(null);

    const stepTypes = [
        'click', 'fill', 'type', 'select', 'wait', 'press', 'navigate'
    ];

    const logMessage = (message, type = 'info') => {
        const text = typeof message === 'string' ? message : JSON.stringify(message);
        setLogs(prevLogs => [...prevLogs, { text: text, type: type, id: uuidv4() }]);
    };

    // --- Step Management (No changes) ---
    const handleAddStep = (e) => { e.preventDefault(); if (['click', 'fill', 'type', 'select', 'press'].includes(currentStepType)) { if (!currentSelector) { alert(`Selector is required for step type: ${currentStepType}.`); return; } } if (['fill', 'type', 'select', 'press', 'navigate'].includes(currentStepType) || (currentStepType === 'wait' && !currentSelector)) { if (!currentValue && currentStepType !== 'wait') { alert(`Value is required for step type: ${currentStepType}.`); return; } } const newStep = { id: uuidv4(), type: currentStepType, selector: currentSelector || null, value: currentValue || null }; setSteps([...steps, newStep]); setCurrentSelector(''); setCurrentValue(''); };
    const handleRemoveStep = (idToRemove) => { setSteps(steps.filter(step => step.id !== idToRemove)); };
    const formatStepsForTask = () => { if (steps.length === 0) return ""; let formattedSteps = "\n\nDetailed Steps to Follow:\n"; steps.forEach((step, index) => { formattedSteps += `${index + 1}. Type: ${step.type}`; if (step.selector) formattedSteps += `, Selector: "${step.selector}"`; if (step.value) formattedSteps += `, Value: "${step.value}"`; formattedSteps += "\n"; }); return formattedSteps; };

    // --- handleRunTest Function ---
    const handleRunTest = async () => {
        // ... (rest of handleRunTest remains the same as the last version)
        // ... (constructs combinedTask, calls API)
        if (isRunning) return;
        if (!goal.trim() && steps.length === 0) { alert("Please enter a Goal or add at least one Step before running the agent."); return; }

        const formattedStepsString = formatStepsForTask();
        const goalInstruction = `\n\nYour primary objective is: "${goal}".`;
        // This instruction's output (SUCCESS/FAILURE keyword) is NO LONGER PARSED for pass/fail
        // const finalInstruction = `\n\n**NOTE:** After attempting the steps, evaluate if the primary objective ('${goal}') was successfully achieved. Your evaluation might be logged, but the final Pass/Fail of this test run is determined by whether the automation completed technically without API errors.`; // Modified instruction text for clarity

        const combinedTask = `${goalInstruction}${formattedStepsString}`;

        setIsRunning(true);
        setLogs([]);
        setTaskId(null);
        setLiveUrl(null);
        setStatus('starting');
        setTestResult(null);
        setFinalAgentResultText(null);
        if (pollingIntervalRef.current) { clearInterval(pollingIntervalRef.current); pollingIntervalRef.current = null; }

        logMessage(`Starting agent test for URL: ${targetUrl}`);
        logMessage(`Task being sent to agent:\n${combinedTask}`);

        try {
            const response = await axios.post(`${API_BASE_URL}/api/run-task`, { url: targetUrl, task: combinedTask });
            if (response.data && response.data.taskId && response.data.liveUrl) {
                setTaskId(response.data.taskId);
                setLiveUrl(response.data.liveUrl);
                setStatus('running');
                logMessage(`Agent task created: ID=${response.data.taskId}`, 'success');
                startPolling(response.data.taskId);
            } else { throw new Error(response.data?.error || "Failed to start task: Invalid response from backend."); }
        } catch (error) {
            console.error("Error starting agent task:", error);
            const errorMsg = error.response?.data?.detail || error.message || "An unknown error occurred.";
            logMessage(`Error starting task: ${errorMsg}`, 'error');
            setIsRunning(false);
            setStatus('failed');
            setTestResult('failure');
        }
    };

    // --- handleStopTest Function ---
    const handleStopTest = async () => {
        if (!isRunning || !taskId) {
            return; // Nothing to stop
        }

        logMessage(`Attempting to stop task ID: ${taskId}...`);

        try {
            // Updated to use PUT method to match the server endpoint
            const response = await axios.put(`${API_BASE_URL}/api/task/${taskId}/stop`);

            if (response.data && response.data.status === 'stopped') {
                logMessage(`Task ${taskId} stopped successfully`, 'success');
                // We'll let the polling function handle the state updates when it detects the stopped status
            } else {
                logMessage(`Task stop request sent. Waiting for confirmation...`, 'info');
                // Even if we don't get a clear "stopped" status, the request might still be processing
            }
        } catch (error) {
            console.error("Error stopping agent task:", error);
            const errorMsg = error.response?.data?.detail || error.message || "An unknown error occurred.";
            logMessage(`Error stopping task: ${errorMsg}`, 'error');
            // Don't change running state here - let polling handle it
        }
    };

    // --- Polling for Task Status and Logs ---
    const startPolling = (currentTaskId) => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
        }

        pollingIntervalRef.current = setInterval(async () => {
            if (!currentTaskId) {
                 clearInterval(pollingIntervalRef.current);
                 pollingIntervalRef.current = null;
                 return;
             }

            try {
                const response = await axios.get(`${API_BASE_URL}/api/task/${currentTaskId}/details`);
                const data = response.data; // Expects { status: ..., output: ..., live_url: ... }

                if (data.status) {
                     setStatus(data.status);
                }

                // Log handling remains the same - display final output when finished
                // (As noted before, intermediate logs require backend changes)

                const terminalStatuses = ['finished', 'failed', 'stopped', 'error'];
                if (terminalStatuses.includes(data.status)) {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                    setIsRunning(false);

                    // === MODIFICATION START: Enhanced robust keyword analysis of agent's "output" with goal matching ===
                    let finalOutcome = 'failure'; // Default to failure unless positive keywords found AND no negative keywords found
                    const agentOutput = data.output;
                    setFinalAgentResultText(agentOutput || "No final output text provided by agent.");

                    logMessage(`Received final agent output:\n---\n${agentOutput || '(No output received)'}\n---`);

                    if (agentOutput && typeof agentOutput === 'string') {
                        const outputLower = agentOutput.toLowerCase(); // Case-insensitive matching
                        const goalLower = goal.toLowerCase().trim(); // Get the original goal for comparison

                        // Define keywords indicating failure (prioritize these)
                        const negativeKeywords = [
                            "fail", "failed", "error", "unable", "could not",
                            "invalid", "incorrect", "exception", "problem",
                            "cannot", "can't", "did not complete", "not successful"
                        ];

                        // Define keywords indicating success
                        const positiveKeywords = [
                            "success", "successfully", "completed", "accessed",
                            "verified", "achieved", "logged in", "dashboard accessed", // Add domain specific terms
                            "objective met", "goal achieved", "confirmed", "validated",
                            "works correctly" // From user example
                        ];

                        // --- PART 1: Check for goal-specific analysis (HIGHEST PRIORITY) ---
                        let goalMentioned = false;
                        let goalAchieved = false;
                        let goalAnalysisConclusive = false;

                        // Only proceed with goal analysis if we have a non-empty goal
                        if (goalLower && goalLower.length > 0) {
                            logMessage("Starting deep goal-specific analysis (highest priority)...", "info");

                            // STEP 1: Extract meaningful components from the goal
                            // First, clean up the goal text
                            const cleanGoal = goalLower.replace(/[.,;:!?()]/g, ' ').replace(/\s+/g, ' ').trim();

                            // Extract key phrases (3+ character words, excluding common stop words)
                            const stopWords = ["the", "and", "that", "this", "with", "from", "have", "your", "for", "are", "will", "can", "should", "would", "could", "was", "were", "has", "been", "being", "its", "their", "our", "his", "her"];
                            const goalKeyPhrases = cleanGoal
                                .split(/\s+/)
                                .filter(word => word.length >= 3)
                                .filter(word => !stopWords.includes(word));

                            // Extract noun phrases (2+ consecutive words that might form a concept)
                            const goalWords = cleanGoal.split(/\s+/);
                            const nounPhrases = [];
                            for (let i = 0; i < goalWords.length - 1; i++) {
                                if (!stopWords.includes(goalWords[i]) && !stopWords.includes(goalWords[i+1])) {
                                    nounPhrases.push(`${goalWords[i]} ${goalWords[i+1]}`);
                                }
                            }

                            // Extract verbs and actions
                            const goalVerbs = extractVerbs(goalLower);

                            logMessage(`Extracted ${goalKeyPhrases.length} key phrases, ${nounPhrases.length} noun phrases, and ${goalVerbs.length} action verbs from goal`, "info");

                            // STEP 2: Perform deep semantic matching with output

                            // 2.1: Check for key phrases in output
                            let matchedPhrases = 0;
                            let matchedKeyPhrases = [];
                            for (const phrase of goalKeyPhrases) {
                                if (outputLower.includes(phrase)) {
                                    matchedPhrases++;
                                    matchedKeyPhrases.push(phrase);
                                    logMessage(`Goal key phrase match: "${phrase}"`, "info");
                                }
                            }

                            // 2.2: Check for noun phrases in output (these are more significant)
                            let matchedNounPhrases = 0;
                            for (const phrase of nounPhrases) {
                                if (outputLower.includes(phrase)) {
                                    matchedNounPhrases++;
                                    logMessage(`Goal noun phrase match: "${phrase}"`, "success");
                                }
                            }

                            // 2.3: Calculate semantic match score (weighted)
                            // Noun phrases are weighted more heavily as they represent core concepts
                            const phraseMatchScore = goalKeyPhrases.length > 0 ?
                                (matchedPhrases / goalKeyPhrases.length) : 0;
                            const nounPhraseMatchScore = nounPhrases.length > 0 ?
                                (matchedNounPhrases / nounPhrases.length) : 0;

                            // Combined score with noun phrases weighted 2x
                            const semanticMatchScore = phraseMatchScore * 0.4 + nounPhraseMatchScore * 0.6;

                            logMessage(`Semantic match analysis: Score=${semanticMatchScore.toFixed(2)} (Key phrases: ${matchedPhrases}/${goalKeyPhrases.length}, Noun phrases: ${matchedNounPhrases}/${nounPhrases.length})`, "info");

                            // If semantic match is strong enough, consider the goal mentioned
                            if (semanticMatchScore >= 0.4 || matchedNounPhrases >= 2 || matchedPhrases >= 3) {
                                goalMentioned = true;
                                logMessage(`Goal is sufficiently mentioned in the output (Semantic match score: ${semanticMatchScore.toFixed(2)})`, "success");
                            } else {
                                logMessage(`Goal is not sufficiently mentioned in the output (Semantic match score: ${semanticMatchScore.toFixed(2)})`, "error");
                            }

                            // STEP 3: Check for goal achievement indicators

                            // 3.1: Check for explicit achievement phrases
                            const goalAchievedPhrases = [
                                "goal accomplished", "goal achieved", "objective met", "objective achieved",
                                "task completed", "successfully completed", "completed successfully",
                                "was successful", "is successful", "succeeded in", "successfully performed",
                                "mission accomplished", "requirement met", "criteria met"
                            ];

                            // 3.2: Check for goal-specific success patterns
                            // Format: "successfully <verb from goal>" or "<verb from goal> successfully"
                            // or "<verb from goal> correctly/properly/as expected"

                            let achievementEvidence = [];

                            // Check for general achievement phrases
                            for (const phrase of goalAchievedPhrases) {
                                if (outputLower.includes(phrase)) {
                                    goalAchieved = true;
                                    achievementEvidence.push(phrase);
                                    logMessage(`Goal achievement indicator found: "${phrase}"`, "success");
                                }
                            }

                            // Check for verb-specific achievement patterns
                            if (goalVerbs.length > 0) {
                                for (const verb of goalVerbs) {
                                    const verbPatterns = [
                                        `successfully ${verb}`,
                                        `${verb} successfully`,
                                        `${verb} correctly`,
                                        `${verb} properly`,
                                        `${verb} as expected`,
                                        `${verb} without error`,
                                        `${verb} without issue`,
                                        `able to ${verb}`,
                                        `managed to ${verb}`
                                    ];

                                    for (const pattern of verbPatterns) {
                                        if (outputLower.includes(pattern)) {
                                            goalAchieved = true;
                                            achievementEvidence.push(pattern);
                                            logMessage(`Goal-specific success pattern found: "${pattern}"`, "success");
                                        }
                                    }
                                }
                            }

                            // 3.3: Check for goal-specific failure patterns
                            const failurePatterns = [
                                "not achieved", "couldn't achieve", "unable to achieve", "failed to achieve",
                                "was not successful", "is not successful", "did not succeed", "wasn't successful",
                                "wasn't able to", "could not", "unable to", "failed to", "did not work",
                                "doesn't work", "didn't work", "not working", "unsuccessful"
                            ];

                            let failureEvidence = [];
                            for (const pattern of failurePatterns) {
                                if (outputLower.includes(pattern)) {
                                    failureEvidence.push(pattern);
                                    logMessage(`Goal failure indicator found: "${pattern}"`, "error");
                                }
                            }

                            // STEP 4: Context-aware analysis of goal achievement

                            // Check if the output explicitly states whether the goal was achieved
                            const goalTerms = ["goal", "objective", "task", "aim", "purpose"];
                            let explicitGoalMention = false;

                            for (const term of goalTerms) {
                                if (outputLower.includes(term)) {
                                    explicitGoalMention = true;
                                    logMessage(`Output explicitly mentions "${term}"`, "info");
                                    break;
                                }
                            }

                            // Look for sentences that contain both goal key phrases and achievement indicators
                            // This is a simplified sentence analysis - in a real NLP system, we'd parse sentences properly
                            const sentences = outputLower.split(/[.!?]+/).filter(s => s.trim().length > 0);
                            let goalAchievementSentences = 0;

                            for (const sentence of sentences) {
                                let containsGoalPhrase = false;
                                let containsAchievementTerm = false;

                                // Check if sentence contains any goal key phrase
                                for (const phrase of matchedKeyPhrases) {
                                    if (sentence.includes(phrase)) {
                                        containsGoalPhrase = true;
                                        break;
                                    }
                                }

                                // Check if sentence contains achievement terms
                                const achievementTerms = ["success", "achieved", "completed", "accomplished", "worked", "able to"];
                                for (const term of achievementTerms) {
                                    if (sentence.includes(term)) {
                                        containsAchievementTerm = true;
                                        break;
                                    }
                                }

                                if (containsGoalPhrase && containsAchievementTerm) {
                                    goalAchievementSentences++;
                                    logMessage(`Found sentence linking goal and achievement: "${sentence.trim()}"`, "success");
                                }
                            }

                            // STEP 5: Make a conclusive determination based on all evidence

                            // Strong evidence for success
                            if (goalMentioned && (goalAchieved || goalAchievementSentences > 0) && failureEvidence.length === 0) {
                                finalOutcome = 'success';
                                goalAnalysisConclusive = true;
                                logMessage("Goal analysis conclusive: Goal mentioned and achievement evidence found without contradicting failure indicators", "success");
                            }
                            // Strong evidence for failure
                            else if (goalMentioned && failureEvidence.length > 0) {
                                finalOutcome = 'failure';
                                goalAnalysisConclusive = true;
                                logMessage("Goal analysis conclusive: Goal mentioned with explicit failure indicators", "error");
                            }
                            // Moderate evidence for success
                            else if (goalMentioned && semanticMatchScore > 0.6) {
                                finalOutcome = 'success';
                                goalAnalysisConclusive = true;
                                logMessage("Goal analysis conclusive: Strong semantic match with goal content suggests success", "success");
                            }
                            // Explicit goal discussion but unclear outcome
                            else if (explicitGoalMention && goalMentioned) {
                                // If the output explicitly discusses the goal but doesn't clearly state success/failure,
                                // we need to look at the overall tone
                                const positiveTerms = ["success", "successful", "achieved", "completed", "works", "working"];
                                const negativeTerms = ["fail", "failed", "error", "issue", "problem", "not working"];

                                let positiveCount = 0;
                                let negativeCount = 0;

                                for (const term of positiveTerms) {
                                    if (outputLower.includes(term)) positiveCount++;
                                }

                                for (const term of negativeTerms) {
                                    if (outputLower.includes(term)) negativeCount++;
                                }

                                if (positiveCount > negativeCount) {
                                    finalOutcome = 'success';
                                    goalAnalysisConclusive = true;
                                    logMessage("Goal analysis conclusive: Goal explicitly discussed with more positive than negative indicators", "success");
                                } else if (negativeCount > positiveCount) {
                                    finalOutcome = 'failure';
                                    goalAnalysisConclusive = true;
                                    logMessage("Goal analysis conclusive: Goal explicitly discussed with more negative than positive indicators", "error");
                                }
                            }

                            // If we still don't have a conclusive result, we'll proceed to keyword analysis
                            if (!goalAnalysisConclusive) {
                                logMessage("Goal analysis inconclusive: Will proceed to general keyword analysis", "info");
                            }
                        } else {
                            logMessage("No specific goal provided, skipping goal analysis", "info");
                        }

                        // --- PART 2: Check for negative/positive keywords (only if goal analysis was inconclusive) ---
                        let foundNegative = false;
                        let foundPositive = false;

                        if (!goalAnalysisConclusive) {
                            logMessage("Goal analysis inconclusive, checking for positive/negative indicators...", "info");

                            // Check for negative keywords
                            for (const keyword of negativeKeywords) {
                                if (outputLower.includes(keyword)) {
                                    logMessage(`Detected failure indicator: "${keyword}"`, "error");
                                    foundNegative = true;
                                    break; // Stop checking negatives if one is found
                                }
                            }

                            // Check for positive keywords
                            if (!foundNegative) {
                                for (const keyword of positiveKeywords) {
                                    if (outputLower.includes(keyword)) {
                                        logMessage(`Detected success indicator: "${keyword}"`, "success");
                                        foundPositive = true;
                                        break; // Stop checking positives if one is found
                                    }
                                }
                            }
                        }

                        // --- PART 3: Determine final outcome based on all factors ---
                        if (goalAnalysisConclusive) {
                            // Goal analysis was conclusive, we already set finalOutcome
                            logMessage(`Final determination based on goal analysis: ${finalOutcome.toUpperCase()}`,
                                      finalOutcome === 'success' ? "success" : "error");
                        } else if (goalLower && goalLower.length > 0) {
                            // Goal provided but analysis was inconclusive
                            if (goalMentioned && foundPositive) {
                                finalOutcome = 'success';
                                logMessage("Goal is mentioned and positive indicators found", "success");
                            } else if (foundNegative) {
                                finalOutcome = 'failure';
                                logMessage("Negative indicators found", "error");
                            } else if (foundPositive) {
                                finalOutcome = 'success';
                                logMessage("Positive indicators found, but goal achievement is unclear", "info");
                            } else {
                                finalOutcome = 'failure';
                                logMessage("No clear indication that the goal was achieved", "error");
                            }
                        } else {
                            // No goal provided, rely on general positive/negative keywords
                            if (foundNegative) {
                                finalOutcome = 'failure';
                                logMessage("No goal provided, negative indicators found", "error");
                            } else if (foundPositive) {
                                finalOutcome = 'success';
                                logMessage("No goal provided, positive indicators found", "success");
                            } else {
                                finalOutcome = 'failure';
                                logMessage("No goal provided, no positive indicators found", "error");
                            }
                        }
                    } else {
                         logMessage("Agent finished but provided no text output to analyze.", "error");
                         // finalOutcome remains 'failure'
                    }

                    // --- Keep Override Logic: API technical failure means test failure ---
                    if(data.status === 'failed' || data.status === 'error'){
                        finalOutcome = 'failure'; // Force failure
                        logMessage(`API task status is ${data.status}, overriding final outcome to FAILURE.`, "error");
                    } else if (data.status === 'stopped') {
                        finalOutcome = 'failure'; // Stopped tasks are considered failures
                        logMessage(`Task was manually stopped by user.`, "info");
                    }
                    // --- End Override Logic ---

                    setTestResult(finalOutcome);
                    logMessage(`Polling stopped. Final API Status: ${data.status}. Determined Outcome based on Output Analysis: ${finalOutcome.toUpperCase()}`, finalOutcome === 'success' ? 'success' : 'error');
                    // === MODIFICATION END ===
                }

            } catch (error) {
                 // --- Keep Existing Error Handling for Polling ---
                console.error("Error polling task status:", error);
                logMessage(`Error polling status: ${error.message}`, 'error');
                 if (error.response?.data?.detail) {
                     logMessage(`Backend polling error: ${error.response.data.detail}`, 'error');
                 }
                 if (error.response?.status === 404) {
                     logMessage(`Task ID ${currentTaskId} not found. Stopping polling.`, 'error');
                     clearInterval(pollingIntervalRef.current);
                     pollingIntervalRef.current = null;
                     setIsRunning(false);
                     setStatus('error');
                     setTestResult('failure');
                 }
            }
        }, 3000); // Poll every 3 seconds
    };

     // --- Cleanup Polling on Unmount ---
     useEffect(() => { return () => { if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current); }; }, []);

     // Auto-scroll logs pane
     useEffect(() => { rightPanelEndRef.current?.scrollIntoView({ behavior: "smooth" }); }, [logs]);


    return (
        <div className="testing-page">
            {/* Left Panel (No changes needed in JSX structure) */}
            <div className="left-panel">
                 <h2 className="panel-title">Agent Configuration</h2>
                 <div className="input-group">
                     <label htmlFor="goal">Overall Goal / Objective</label>
                     <textarea id="goal" value={goal} onChange={(e) => setGoal(e.target.value)} placeholder="Describe the main objective..." rows={3} />
                 </div>
                 <h3 className="panel-title steps-title">Detailed Steps (Optional Guidance)</h3>
                 <div className="steps-list">
                     {steps.length === 0 && <p className="no-steps-msg">No specific steps added.</p>}
                     {steps.map((step) => ( <div key={step.id} className="step-item"><span className="step-type-badge">{step.type}</span><div className="step-details">{step.selector && <div><span>Selector:</span> {step.selector}</div>}{step.value && <div><span>Value:</span> {step.value}</div>}</div><div className="step-actions"><button onClick={() => handleRemoveStep(step.id)} title="Remove Step">×</button></div></div> ))}
                 </div>
                 <form className="add-step-form" onSubmit={handleAddStep}>
                     <h4>Add New Step</h4>
                     <div className="add-step-controls">
                         <select value={currentStepType} onChange={(e) => setCurrentStepType(e.target.value)}> {stepTypes.map(type => <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)} </select>
                         <input type="text" placeholder="Selector (e.g., #id, .class)" value={currentSelector} onChange={(e) => setCurrentSelector(e.target.value)} aria-label="CSS Selector"/>
                         <input type="text" placeholder="Value (e.g., text, URL, key)" value={currentValue} onChange={(e) => setCurrentValue(e.target.value)} aria-label="Value"/>
                     </div>
                     <button type="submit" className="add-step-button">Add Step</button>
                 </form>
                <div className="button-container" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                    <button
                        className="run-button"
                        onClick={handleRunTest}
                        disabled={isRunning || (!goal.trim() && steps.length === 0)}
                    >
                        {isRunning ? 'Agent Running...' : 'Run Agent Test'}
                    </button>

                    {isRunning && taskId && (
                        <button
                            className="stop-button"
                            onClick={handleStopTest}
                        >
                            Stop Agent
                        </button>
                    )}
                </div>
            </div>

            {/* Right Panel (UPDATED for full width iframe) */}
            <div className="right-panel">
                 <div className="live-view-section">
                     <div className="live-view-iframe-container">
                         <iframe
                             src={liveUrl || targetUrl}
                             key={liveUrl || targetUrl}
                             className="live-view-iframe"
                             title="Live Preview / Initial Site View"
                             allowFullScreen
                             sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                             importance="high"
                             loading="eager"
                             referrerPolicy="no-referrer"
                         />
                     </div>
                 </div>
                 {/* Logs section is hidden via CSS */}
                 <div className="logs-section">
                      <h2 className="panel-title">AI OUTPUT LOGS</h2>
                      <div className="status-log" style={{ flexGrow: 1, overflowY: 'auto' }}>
                          {logs.map((log) => ( <div key={log.id} className={`log-entry ${log.type === 'error' ? 'log-error' : ''} ${log.type === 'success' ? 'log-success' : ''}`}> <span style={{ whiteSpace: 'pre-wrap' }}>{log.text}</span> </div> ))}
                          <div ref={rightPanelEndRef} />
                      </div>
                  </div>
                 {/* Test result is hidden via CSS */}
                 {testResult && ( <div style={{ padding: '10px', borderRadius: '4px', backgroundColor: testResult === 'success' ? '#d4edda' : '#f8d7da', color: testResult === 'success' ? '#155724' : '#721c24', marginTop: '10px' }}> Final Test Result: {testResult.toUpperCase()} </div> )}
            </div>
        </div>
    );
};

export default TestingPage;
